module.exports = __webpack_public_path__ + "img/c8.e05d1016.png";